import React, { useContext } from 'react';
import { ulid } from 'ulid';
import { useSelector } from 'react-redux';

import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import { ReactComponent as CloudArrowUp } from '../../../assets/icons/CloudArrowUp.svg';
import { ReactComponent as File } from '../../../assets/icons/File.svg';
import Context from '../../../store/context';
import BackButton from '../../Buttons/BackButton/BackButton';
import Button from '../../Buttons/Button/Button';
import DropFiles from '../../DropFiles/DropFiles/DropFiles';

import classes from './SomeSuppliers.module.scss';
import utils from '../../../services/utils';

const typeFile = {
  'text/csv': ['.csv'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
};

const SomeSuppliers = ({ refetch, backButtonHandler, setCurrentStep, fileUpload, setFileUpload, uploadFiles }) => {
  const { businessId } = useSelector(state => state.userData);

  const {
    // toast: { showSuccess },
    modal: { showError }
  } = useContext(Context);

  const changeOtherFile = async file => {
    if (file) {
      setFileUpload(file);
    }
  };

  const downloadFile = () => {
    utils.downloadFileByUrl('https://meloapp-public-assets.s3.us-east-2.amazonaws.com/plantilla-cargue-proveedores.xlsx');
  };

  const addSuppliers = async () => {
    const [extension] = fileUpload.name.split('.').slice(-1);
    const path = `businesses/${businessId}/supplier/load-suppliers/${ulid()}.${extension}`;
    try {
      uploadFiles(path, extension);
      await Storage.put(path, fileUpload);
      // createSuppliersByFile(businessId, path);
    } catch (error) {
      showError({ title: 'Crear proveedores', description: error });
    }
  };

  return (
    <div className={classes.content}>
      <BackButton onClick={backButtonHandler} className={classes.back} />
      <span className='bold-20'>Agregar proveedores</span>
      <span className={`${classes['download-text']} semibold-18`}>
        Descarga la plantilla de proveedores y vuélvela a subir diligenciada
      </span>
      <Button onClick={downloadFile} custom='quaternary' Icon={ArrowDownLine}>
        Descargar plantilla
      </Button>

      <DropFiles
        className={classes['content-card']}
        maxSize={500000}
        typeFile={typeFile}
        maxFiles={1}
        onDroppedFiles={files => changeOtherFile(files[0])}>
        <CloudArrowUp />
        <span className={`semibold-16 ${classes.text}`}>
          {!fileUpload ? 'Arrastra aquí o' : 'Si quieres reemplazar el archivo arrastra aquí uno nuevo o'}
        </span>
        <Button>{!fileUpload ? 'Carga el archivo' : 'Cargar nuevo archivo'}</Button>
        <span className={`medium-14 ${classes.color}`}>.csv, .xls ó .xlsx de máximo 500 KB</span>
      </DropFiles>

      {fileUpload && (
        <div className={classes['position-card-upload']}>
          <File />
          <span className='semibold-16'>{fileUpload.name}</span>
        </div>
      )}
      <div className={classes.down}>
        <Button onClick={addSuppliers} enabled={!!fileUpload}>
          Subir proveedores
        </Button>
      </div>
    </div>
  );
};

export default SomeSuppliers;
